import { render, staticRenderFns } from "./DataAssetTransactions.vue?vue&type=template&id=5a91f05b&"
import script from "./DataAssetTransactions.vue?vue&type=script&lang=js&"
export * from "./DataAssetTransactions.vue?vue&type=script&lang=js&"
import style0 from "./DataAssetTransactions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a91f05b')) {
      api.createRecord('5a91f05b', component.options)
    } else {
      api.reload('5a91f05b', component.options)
    }
    module.hot.accept("./DataAssetTransactions.vue?vue&type=template&id=5a91f05b&", function () {
      api.rerender('5a91f05b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DataAssetTransactions.vue"
export default component.exports